import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import withContext from 'hoc/withContext';
import { firstLetterToUpperCase } from 'services/utils/string';

const Td = styled.td`
  background-color: ${({ primary, secondary, theme }) => {
    if (primary) return theme.blowGreenLight;
    if (secondary) return theme.blowWarningLight;
  }};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
`;
const Tr = styled.tr`
  background-color: ${({ type, theme }) => {
    if (type) return theme.items[type];
    return 'inherit';
  }};
`;

const ListRow = ({ item, order, index }) => {
  return (
    <Tr type={item.includedToPrice ? null : 'notIncludedToPrice'}>
      <td>{index + 1}</td>
      <td>{firstLetterToUpperCase(item.type)}</td>
      <td>{item.quantity}</td>
      <td>{item.comments}</td>
    </Tr>
  );
};

export default ListRow;
